import { ApiResponse, http } from '@config/api';

export interface RegisterPayload {
	email: string;
	password: string;
	role: Role;
}

export interface LoginPayload {
	email: string;
	password: string;
}

export interface LoginResponse {
	accessToken: string;
	refreshToken: string;
	isVerified: boolean;
}

export type Role = 'farmer' | 'specialist';

export async function registerService({ email, password, role }: RegisterPayload) {
	const response = await http.post<ApiResponse<LoginResponse>>('auth', 'register', {
		email,
		password,
		role,
	});

	return response.data;
}

export async function registerWithGoogleService({ role, code }: { role: string; code: string }) {
	const response = await http.post<ApiResponse<{ access_token: string }>>(
		'auth',
		'google/register',
		{
			role,
			code,
		}
	);

	return response.data;
}

export async function loginService({
	email,
	password,
}: LoginPayload): Promise<ApiResponse<LoginResponse>> {
	const response = await http.post<ApiResponse<LoginResponse>>('auth', 'login', {
		email,
		password,
	});

	return response.data;
}

export async function loginWithGoogleService(code: string): Promise<ApiResponse<LoginResponse>> {
	const response = await http.post<ApiResponse<LoginResponse>>('auth', 'google/login', {
		code,
	});

	return response.data;
}

export async function changePasswordService({
	oldPassword,
	newPassword,
}: {
	oldPassword: string;
	newPassword: string;
}) {
	const response = await http.post<ApiResponse<void>>('auth', 'change-password', {
		oldPassword,
		newPassword,
	});

	return response.data;
}

export async function switchRoleService({ role }: { role: Role }) {
	// Using the direct API call method for the specific endpoint as specified by the user
	const response = await http.post<ApiResponse<LoginResponse>>('auth', 'role-switch', { role });

	return response.data;
}

export async function logoutService(refreshToken: string) {
	const response = await http.post<ApiResponse<void>>('auth', 'logout', {
		refreshToken,
	});

	return response.data;
}

export async function refreshTokenService(refreshToken: string) {
	const response = await http.post<ApiResponse<LoginResponse>>('auth', 'refresh-token', {
		refreshToken,
	});

	return response.data.data;
}

export async function forgotPasswordService(email: string) {
	const response = await http.post<ApiResponse<any>>('auth', 'forgot-password', { email });

	return response.data;
}
export async function resetPasswordWithTokenService(password: string, token: string) {
	const response = await http.post<ApiResponse<void>>('auth', 'reset-password-with-token', {
		password,
		token,
	});

	return response.data;
}

export async function validateResetPasswordTokenService(token: string) {
	const response = await http.post<ApiResponse<{ isValid: boolean }>>(
		'auth',
		'validate-reset-password-token',
		{
			token,
		}
	);

	return response.data;
}
